import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import custom from "./custom";

Vue.use(Vuetify);
Vue.use(custom);

export default new Vuetify({});
